// Configuración incrustada en el build (variables PUBLIC_*). Sin secretos: esto es público.
//
// OJO: Bun solo sustituye `process.env.PUBLIC_X` por su valor si la variable EXISTE al
// compilar; si no, el código queda leyendo `process`, que no existe en el navegador. Por
// eso cada lectura va dentro de `readPublicEnv`, que cae al valor por defecto.
export const readPublicEnv = (read: () => string | undefined, fallback: string): string => {
	try {
		return read() ?? fallback
	} catch {
		return fallback
	}
}

export const normalizeBaseUrl = (url: string): string => url.trim().replace(/\/+$/, '')

export const API_URL = normalizeBaseUrl(readPublicEnv(() => process.env.PUBLIC_API_URL, 'http://localhost:3000'))

// Estilo del mapa base. Por defecto OpenFreeMap (gratuito, sin clave, datos de OpenStreetMap).
export const MAP_STYLE_URL = readPublicEnv(
	() => process.env.PUBLIC_MAP_STYLE_URL,
	'https://tiles.openfreemap.org/styles/liberty'
)
